/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { useTheme } from "@mui/material/styles";
import React from "react";
import { Paper, Stack, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import StyleguideView from "@/src/styleguide/components/StyleguideView/StyleguideView.tsx";
import { mergeSx } from "@/src/utils/mergeSx.ts";
import { colorStyleguideStyle } from "@/src/styleguide/ColorStyleguide/colorStyleguideStyle.ts";

export default function ColorStyleguide() {
  const theme = useTheme();

  const paletteEntries = Object.entries(theme.palette).filter(([key, value]) => {
    return !["mode"].includes(key) && (typeof value === "object" || typeof value === "string");
  });

  return paletteEntries.map(([colorKey, colorValue]) => {
    let colorValueKeys: string[] = [];

    switch (typeof colorValue) {
      case "object":
        colorValueKeys = Object.keys(colorValue);
        break;
      case "string":
        colorValueKeys = [colorKey];
    }

    return (
      <StyleguideView key={colorKey} title={colorKey[0].toUpperCase() + colorKey.slice(1)}>
        <Grid container spacing={2}>
          {colorValueKeys.map((prop) => {
            const colorEntry = paletteEntries.find(([key]) => key === colorKey)?.[1];
            let colorHex: string | null = null;

            switch (typeof colorEntry) {
              case "object":
                colorHex = colorEntry[prop];
                break;
              case "string":
                colorHex = colorEntry;
                break;
            }

            if (!colorHex || typeof colorHex !== "string") {
              return null;
            }

            const isGradient = colorHex?.includes("gradient");

            return (
              <Grid
                key={prop}
                size={{
                  xs: 12,
                  sm: 4,
                  lg: 2,
                }}
              >
                <Stack sx={{ height: "100%" }}>
                  <Paper
                    sx={mergeSx(colorStyleguideStyle.paper, (theme) => ({
                      background: colorHex,
                      color: !isGradient ? theme.palette.getContrastText(colorHex) : null,
                      minHeight: isGradient ? "6rem" : null,
                    }))}
                    elevation={0}
                  >
                    {!isGradient && (
                      <Typography variant="body1" sx={{ wordBreak: "break-all" }}>
                        {prop}
                      </Typography>
                    )}
                    {!isGradient && <Typography variant="body2">{colorHex}</Typography>}
                  </Paper>
                  {isGradient && (
                    <Typography variant="body1" sx={{ wordBreak: "break-all", padding: "0.5rem" }}>
                      {prop}
                    </Typography>
                  )}
                </Stack>
              </Grid>
            );
          })}
        </Grid>
      </StyleguideView>
    );
  });
}
